import script from "./itemPage.vue?vue&type=script&setup=true&lang=js"
export * from "./itemPage.vue?vue&type=script&setup=true&lang=js"

import "./itemPage.vue?vue&type=style&index=0&id=e077f058&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e077f058"]])

export default __exports__